import { initStateDropDownBox } from '../state-dropdown';
import { localCountryMapper } from './country-mapper';
import { localStateMapper } from './state-mapper';


export const configureAutoComplete = () => {
	const triggerElem = document.getElementById('address1');
	autocomplete(triggerElem);
}
	
const autocomplete = (triggerElem) => {
	if (!!triggerElem) {
		const placeHolder = googleAutocomplete(triggerElem);

		google.maps.event.addListener(placeHolder, 'place_changed', () => {
			fillInAddress(placeHolder.getPlace());
		});
	}
};

const googleAutocomplete = (elem) => {
	google.maps.event.clearInstanceListeners(elem);
	
	return new google.maps.places.Autocomplete((elem), {
		types: [`address`],
	});
}

const resetFormComponents = (formComponents) => {
	Object.entries(formComponents).map(item => {
		const elem = document.getElementById(item);
		if (!!elem) {
			elem.value = '';
			elem.disabled = false;
		}
	})

	document.getElementById('address2').value = '';
	document.getElementById('state').value = '';
}
/**
 * Listner method that gets called when user selects address from Google Autocomplete
 */
const fillInAddress = (place) => {

	let stateLists= [];
	
    let street="";
    let routee;
    let countryId= false;
    let stateAbb= false;
    let stateFull;
    let stateAbb2= false;
    let stateFull2;
    let stateId= false;
    
    const componentForm = {
			locality: 'long_name',  //city
			postal_code: 'short_name',  //zip or postal code
			postal_town: 'long_name,'	  
    };

		resetFormComponents(componentForm);


    let addressType = '';
    for (var i = 0; i < place.address_components.length; i++) {
      addressType = place.address_components[i].types[0];
      
      //handle city and zip code
      if (componentForm[addressType]) {
        let val = place.address_components[i][componentForm[addressType]] || "";
        // if ( val == undefined ) val = "";
        if ( document.getElementById(addressType) ) document.getElementById(addressType).value = val;
        
        if ( addressType == "postal_town" ) {
        	if ( val == "" ) {
        		val = place.address_components[i][componentForm["street_number"]];
        		if ( val == undefined ) val = "";
        	}	
        	document.getElementById("locality").value = val;
        }
			}
			

      //handle country
      if(addressType=='country'){
    	  var country = place.address_components[i]['short_name'];
    	  const curCountry= document.getElementById('country').value;
    	  if(localCountryMapper[country.toLowerCase()]){
    		  countryId = localCountryMapper[country.toLowerCase()];
    		  document.getElementById('country').value= countryId;
    		  if(curCountry !== countryId){
    			  initStateDropDownBox();
    		  }
    	  }
      }
      
      
      // Handle state Phase I
      // indicates a first-order civil entity below the country level. 
      // Within the United States, these administrative levels are states. 
      // Not all nations exhibit these administrative levels. In most cases, 
      // administrative_area_level_1 short names will closely match ISO 3166-2 
      // subdivisions and other widely circulate
      // For USA, this will be states - not applicable for all countries 
      if(addressType=='administrative_area_level_1'){
    	  stateAbb = place.address_components[i]['short_name'];
    	  stateFull = place.address_components[i]['long_name'];
    	  stateAbb = stateAbb.toLowerCase();
    	  stateFull = stateFull.toLowerCase();
      }
      
      
      // Handle state Phase II
      // indicates a second-order civil entity below the country level. 
      // Within the United States, these administrative levels are counties. 
      // Not all nations exhibit these administrative levels.
      if(addressType =='administrative_area_level_2'){
    	  stateAbb2 = place.address_components[i]['short_name'];
    	  stateFull2 = place.address_components[i]['long_name'];
    	  stateAbb2 = stateAbb2.toLowerCase();
    	  stateFull2 = stateFull2.toLowerCase();
      }
      
      //handle street address
      if (addressType == 'street_number' ||  addressType == 'postal_town' ) {
          street = place.address_components[i]['long_name'];
          if(street.length >=1){
          	street = street; 
          }else{
          	street = "";
          }
      }
      
      // Route
      if (addressType == 'route') {
          routee = place.address_components[i]['long_name'];
      }
      if(routee){
      	document.getElementById('address1').value = street+" "+routee;
      }
      addressType= '';
    }
    
    //Set State from dropdown : handle state Phase II
	if(countryId && stateAbb){
		//look for USA: local state mapper for statelist mapping before making ajax call
		if (localStateMapper[countryId]) {
			stateLists = localStateMapper[countryId];
			if (stateLists[stateAbb]) {
				stateId = stateLists[stateAbb];
				//getStatesList(countryId, stateId);
				// $("#state").val(stateAbb);
				setState(stateId,countryId,1);
			} else {
				//not selecting state
			}
			// $('.js-state-error').html('');
		} else {
			// Not-USA Countries
			$.post(
				'/service/getstatesmatchajax', // url
				{'country':countryId}, // data
				function(data){ 
					stateLists = data;
					
					if(stateLists !== false && stateLists !== null){
						 
						if ( countryId == "101" ) {
							// remove conty from the stToLook
							stateAbb = stateAbb.replace( 'county' , '' ).trim();
						}
						
						const successFirstAttempt = setLookUp(stateAbb,stateFull,stateLists,countryId);
						
						if(successFirstAttempt== false && stateAbb2 !== false){
							setLookUp(stateAbb2,stateAbb2,stateLists,countryId);
						}
						
						
					} else {
						//no states available
					}
				}, // callback
				"json" // type
			);

		}
	}else{
		// no states available
	}
   
    $('.js-state-error').html('');
}

const setLookUp = (stToLookAbb, stToLookbFull, stateLists, countryId) => {
	let stateId='';
	if (stateLists['abb'][stToLookAbb] ) {
		stateId = stateLists['abb'][stToLookAbb];
		setState(stateId,countryId,1);
		return true;
		
	} else if(stateLists['full'][stToLookAbb] ) {
		stateId = stateLists['full'][stToLookAbb];
		setState(stateId,countryId,1);
		return true;
		
	}else if(stateLists['full'][stToLookbFull] ) {
		stateId = stateLists['full'][stToLookbFull];
		setState(stateId,countryId,1);
		return true;
		
	}else if(stateLists['full'][stToLookbFull] ) {
		stateId = stateLists['full'][stToLookbFull];
		setState(stateId,countryId,1);
		return true;
	}
	return false;

}



/**
 * Set state dropdown value
 */
const setState = (stateId, countryId, attemptCounter) => {
	const elemState = document.getElementById("state");
	const countryIdOnState = elemState.getAttribute("data-country");

	const maxAttempt = 6;
	attemptCounter++;

	// 6 -
	if (attemptCounter == (maxAttempt + 1)) {
		elemState.value = stateId;
	}

	// 7 -
	if (attemptCounter > (maxAttempt + 1)) return;

	// 1-5 
	if (countryIdOnState === countryId) {
		elemState.value = stateId;
		return;
	}

	setTimeout(function() {
		setState(stateId, countryId, attemptCounter)
	}, 500)
}

  // const navButton = document.querySelector('button[aria-expanded]');

  //   function toggleNav({ target }) {
  //     const expanded = target.getAttribute('aria-expanded') === 'true' || false;
  //     navButton.setAttribute('aria-expanded', !expanded);
  //   }

  //   navButton.addEventListener('click', toggleNav);
